import { render, staticRenderFns } from "./module_table.vue?vue&type=template&id=00b1a688&scoped=true&"
import script from "./module_table.vue?vue&type=script&lang=js&"
export * from "./module_table.vue?vue&type=script&lang=js&"
import style0 from "./module_table.vue?vue&type=style&index=0&id=00b1a688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1a688",
  null
  
)

export default component.exports